const INSTALL_KEY = Symbol.for("nexoprint.numericInputUx.installed");

export function installNumericInputUx() {
  if (typeof window === "undefined" || typeof document === "undefined") return;
  if (window[INSTALL_KEY]) return;
  window[INSTALL_KEY] = true;

  const clearedInputs = new WeakSet();

  const keepClearedInputBlank = (input) => {
    if (!clearedInputs.has(input) || document.activeElement !== input) return;
    if (input.value !== "" && Number(input.value) === 0) input.value = "";
  };

  document.addEventListener("input", (event) => {
    const input = event.target;
    if (!(input instanceof HTMLInputElement) || input.type !== "number") return;

    if (input.value !== "") {
      clearedInputs.delete(input);
      return;
    }

    clearedInputs.add(input);
    queueMicrotask(() => keepClearedInputBlank(input));
    requestAnimationFrame(() => keepClearedInputBlank(input));
  }, true);

  document.addEventListener("blur", (event) => {
    const input = event.target;
    if (input instanceof HTMLInputElement && input.type === "number") {
      clearedInputs.delete(input);
    }
  }, true);
}
